module.exports = __webpack_public_path__ + "img/preview.6ed1e293.svg";